import "./loading-mask.css";
"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _component = require("../../_utils/component");

var _vueNormalizeComponent = _interopRequireDefault(require("../../_utils/vue-normalize-component.js"));

/* script */
//
//
//
//
//
//
//
//
//
//
//
var __vue_script__ = {
  name: (0, _component.createComponentName)('loading-mask'),
  mixins: [_component.componentMixin],
  props: {
    minHeight: {
      type: Number,
      default: 200
    },
    loading: {
      type: Boolean,
      default: false
    },
    errMsg: {
      type: String,
      default: ''
    }
  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    class: _vm.bem()
  }, [_vm.loading ? _c("div", {
    class: _vm.bem("loading"),
    style: {
      "min-height": _vm.minHeight + "px"
    }
  }, [_c("div", [_c("i", {
    class: _vm.bem("load-icon")
  }), _vm._v("加载中...\n        ")])]) : _vm.errMsg ? _c("div", {
    class: _vm.bem("err")
  }, [_vm._v(_vm._s(_vm.errMsg))]) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

/* style inject */

/* style inject SSR */
var _default = (0, _vueNormalizeComponent.default)({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

exports.default = _default;